import { TextField } from "@mui/material"

import { getNumberTextFieldProps } from "../utils/packaging"

import { FieldRow, FormField } from "@/components/Forms"

interface DimensionsFieldRowProps {
  lengthFieldName: string
  widthFieldName: string
  heightFieldName: string
  uomFieldName?: string
  disabled?: boolean
}

export const DimensionsFieldRow = ({
  lengthFieldName,
  widthFieldName,
  heightFieldName,
  uomFieldName,
  disabled = false,
}: DimensionsFieldRowProps): React.ReactElement => {
  return (
    <FieldRow>
      <FormField
        name={lengthFieldName}
        label='Length (in)'
        render={({ field, fieldState }) => (
          <TextField {...field} data-testid={lengthFieldName} {...getNumberTextFieldProps(fieldState, disabled)} />
        )}
      />
      <FormField
        name={widthFieldName}
        label='Width (in)'
        render={({ field, fieldState }) => (
          <TextField {...field} data-testid={widthFieldName} {...getNumberTextFieldProps(fieldState, disabled)} />
        )}
      />
      <FormField
        name={heightFieldName}
        label='Height (in)'
        render={({ field, fieldState }) => (
          <TextField {...field} data-testid={heightFieldName} {...getNumberTextFieldProps(fieldState, disabled)} />
        )}
      />
      {uomFieldName && <FormField name={uomFieldName} />}
    </FieldRow>
  )
}
